import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/LoyaltyService';
import { LoyaltyRepository } from '~repositories/LoyaltyRepository';

export class LoyaltyEnrolledUseCase {
    private loyaltyRepository: LoyaltyRepository;

    constructor() {
        this.loyaltyRepository = diContainer.get(serviceNames.loyaltyRepository);
    }

    public async execute() {
        await this.loyaltyRepository.updateLoadingStatus();
        await this.loyaltyRepository.fetchLoyaltyInfo();
    }
}
